var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-content"},[_c('div',{staticClass:"error-message"},[_c('h2',{staticClass:"error-title",style:({
        color: _vm.titleColor,
        fontSize: _vm.titleFontSize + 'px'
      })},[_vm._v(_vm._s(_vm.errorTitle))]),_vm._v(" "),_c('p',{staticClass:"error-text",style:({
        color: _vm.descriptionColor
      })},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errorDetails)?_c('p',{staticClass:"error-details",style:({
        borderLeftColor: _vm.highlightColor,
        color: _vm.descriptionColor
      })},[_vm._v(_vm._s(_vm.errorDetails))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7562c50f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyErrorPage.vue
// module id = null
// module chunks = 